var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { InputBase } from '../InputBase';
export default React.forwardRef(function TextField(props, ref) {
    var _a;
    var _b = props.type, type = _b === void 0 ? 'text' : _b, step = props.step, _c = props.intensity, intensity = _c === void 0 ? 'normal' : _c, placeholder = props.placeholder, inputMode = props.inputMode, textFieldStyle = props.textFieldStyle, onPaste = props.onPaste, baseProps = __rest(props, ["type", "step", "intensity", "placeholder", "inputMode", "textFieldStyle", "onPaste"]);
    var dataList = (_a = props.dataList) !== null && _a !== void 0 ? _a : [];
    var datalistId = "".concat(baseProps.name, "-datalist");
    var style = intensity === 'faded' ? { color: 'gray', fontStyle: 'italic' } : {};
    var styles = __assign(__assign({}, style), textFieldStyle);
    var requiredForPlaceHolder = !baseProps.label && baseProps.required;
    var placeholderString = placeholder
        ? "".concat(placeholder, " ").concat(requiredForPlaceHolder ? '*' : '')
        : undefined;
    return (React.createElement(React.Fragment, null,
        !!dataList.length && (React.createElement("datalist", { id: datalistId }, dataList.map(function (option, index) { return (React.createElement("option", { key: index, value: option })); }))),
        React.createElement(InputBase, __assign({}, baseProps, { forwardedRef: ref, inputComponent: function (restProps) { return (React.createElement("input", __assign({ inputMode: inputMode, type: type, step: step, placeholder: placeholderString, autoComplete: 'off', list: datalistId }, restProps, { onPaste: onPaste, style: styles }))); } }))));
});
